import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { SAP_BASIC_01_Schema } from './SAP_BASIC_01_Schema';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';

export const useSearch1 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      SAP_BASIC_01_Schema.mapper.search1,
      context
    );
    return apiRequest(
      'post',
      Global.urls.SafetyPersonnel.getSapBasic01R3,
      params
    );
  }, successOptions);
};
export const useSearch2 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(SAP_BASIC_01_Schema.mapper.search2);

  const query = useQuery({
    queryKey: ['SafetyPersonnel', 'getSapBasic01R2', params],
    queryFn: () =>
      apiRequest('post', Global.urls.SafetyPersonnel.getSapBasic01R2, params),
    enabled: true, // 자동 실행 여부
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
export const useSearch3 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      SAP_BASIC_01_Schema.mapper.search3,
      context
    );
    return apiRequest(
      'post',
      Global.urls.SafetyPersonnel.getSapBasic01R1,
      params
    );
  }, successOptions);
};
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SAP_BASIC_01_Schema.mapper.save1);
    return apiRequest(
      'post1',
      Global.urls.SafetyPersonnel.saveSapBasic01U1,
      payload
    );
  }, options);
};
